import React from "react";
import "./index.scss";
export default function Button({ text, onClick, href }) {
  if (href) {
    return (
      <a className="button" onClick={onClick} role="button" href={href}>
        {text}
      </a>
    );
  }
  return (
    <div className="button" onClick={onClick} role="button">
      {text}
    </div>
  );
}
